import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { BaseRestService } from './base-rest.service';
import { OnDestroy } from '@angular/core';
import { EventService } from './event.service';
import { INoteTypeList, NoteType } from '../models/note';
import { SubjectTypeService } from './subject-type.service';
import { AutoUnsubscribe } from 'auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Injectable({ providedIn: 'root' })
export class NoteTypeService extends BaseRestService<NoteType, INoteTypeList> implements OnDestroy {

  constructor(http: HttpClient, private subjectTypeService: SubjectTypeService, private eventService: EventService, protected router: Router) {
    super(NoteTypeService, http, 'api/notetypes', 'notetype', router);

    // enable caching
    this.cacheEnabled = true;
  }

  ngOnDestroy(): void {
  }

  save(entity: NoteType, successMessage?: string) {
    super.save(entity, successMessage);
  }

  hydrate(item: NoteType): Observable<NoteType> {
    const hydrate$ = [];
    hydrate$.push(of(item));

    if (item.subjectTypeId) {
      hydrate$.push(this.subjectTypeService.getById(item.subjectTypeId).pipe(take(1), map((subjectType) => {
        item.subjectType = subjectType;
        return item;
      })));
    }

    if (hydrate$.length > 0) {
      return forkJoin(hydrate$).pipe(take(1), map((_) => {
        return item;
      }));
    }
    else {
      return of(item);
    }

  }

  // getDescription(id: number): string{
  //   const cache = this.getCache();
  //   const status = cache.find((x) => (x.id === id));
  //   return (status) ? status.name : id.toString();
  // }
}
